/**
 * @generated SignedSource<<8b44e4b52a44ab2c8626f48d2eee7360>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksTrackCurrentItemBase$data = {
  readonly __typename: string;
  readonly " $fragmentSpreads": FragmentRefs<"atomsCurrentArticleAtomBase" | "atomsCurrentNotificationSectionAtomBase">;
  readonly " $fragmentType": "hooksTrackCurrentItemBase";
};
export type hooksTrackCurrentItemBase$key = {
  readonly " $data"?: hooksTrackCurrentItemBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksTrackCurrentItemBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksTrackCurrentItemBase"
};

(node as any).hash = "0bd768bf4d9b2c064472b97ec4f9cd80";

export default node;
